import { MODE_OF_TRANSPORT_EXPRESS_ROAD } from 'shared/ncts/common/constants'
import { RuleResult } from '../../../../types/DeclarationP5'

const validateConsignmentAddressLineRequirement = ({
  security,
}: {
  security: string
}) : RuleResult => (['1', '3'].includes(security) ? 'NOT_ALLOWED' : 'REQUIRED')

const validateHouseConsignmentAddressLineRequirement = ({
  security,
  specificCircumstanceIndicator,
}: {
  security: string
  specificCircumstanceIndicator?: string
}) : RuleResult => (['1', '3'].includes(security) && specificCircumstanceIndicator === MODE_OF_TRANSPORT_EXPRESS_ROAD ? 'NOT_ALLOWED' : 'REQUIRED')

const C0036Validator = {
  validateConsignmentConsigneeAddressLineRequirement: validateConsignmentAddressLineRequirement,
  validateConsignmentConsignorAddressLineRequirement: validateConsignmentAddressLineRequirement,
  validateHouseConsignmentConsigneeAddressLineRequirement: validateHouseConsignmentAddressLineRequirement,
  validateHouseConsignmentConsignorAddressLineRequirement: validateHouseConsignmentAddressLineRequirement,
}

export default C0036Validator
